import { Link } from 'react-router-dom';
import { heuteIso, istUeberfaellig } from '@beholder/shared/module/aufgaben';
import type { GlobalProps } from '../../core/modul';
import { Karte, Laden, Meldung } from '../../core/ui';
import { faelligText, ueberfaelligText, useMeineAufgaben } from './daten';
import './stil.css';

/** „Meine Aufgaben“ über alle Projekte auf der Startseite. */
export function Startkarte(_: GlobalProps) {
  const { liste, fehler } = useMeineAufgaben();
  const heute = heuteIso();
  const ueber = (liste ?? []).filter((a) => istUeberfaellig(a, heute));
  const heuteFaellig = (liste ?? []).filter((a) => a.faellig === heute);
  const zeigen = (liste ?? []).slice(0, 8);

  return (
    <Karte titel="Meine Aufgaben" className="auf-karte auf-startkarte">
      <Meldung>{fehler}</Meldung>
      {!liste ? (
        <Laden />
      ) : liste.length === 0 ? (
        <p className="leise">Dir ist gerade nichts zugewiesen.</p>
      ) : (
        <>
          <div className="auf-karte-zahlen">
            <span>
              <strong>{liste.length}</strong> offen
            </span>
            <span className={ueber.length ? 'auf-text-ueber' : ''}>
              <strong>{ueber.length}</strong> überfällig
            </span>
            <span>
              <strong>{heuteFaellig.length}</strong> heute
            </span>
          </div>
          <ul className="auf-karte-liste">
            {zeigen.map((a) => {
              const u = istUeberfaellig(a, heute);
              return (
                <li key={a.id} className={u ? 'auf-ueberfaellig' : ''}>
                  <Link to={`/p/${a.projektId}/aufgaben/${a.id}`} title={a.titel}>
                    {a.titel}
                    <span className="leise klein auf-startkarte-projekt"> · {a.projektName}</span>
                  </Link>
                  <span className={`klein ${u ? 'auf-text-ueber' : 'leise'}`}>
                    {u ? ueberfaelligText(a, heute) : a.faellig ? faelligText(a.faellig, heute) : ''}
                  </span>
                  <span />
                </li>
              );
            })}
          </ul>
          {liste.length > zeigen.length && <p className="leise klein">… und {liste.length - zeigen.length} weitere</p>}
        </>
      )}
    </Karte>
  );
}
